module.exports = __webpack_public_path__ + "static/media/current-location.269ba03e.svg";